export default function() {

  var loadDefaultDatatables = function() {

      const event = new Event('datatables-scripts-loaded');
      document.dispatchEvent(event);

      $('#contact-table').DataTable({
        order: [[ 4, "desc" ]],
        columnDefs: [
            { "orderable": false, "targets": 1 },
            { "orderable": false, "targets": 2 }
        ],
        responsive: true,
        autoWidth: true,
        pagingType: "simple",
        language: {
          searchPlaceholder: 'Search...',
          sSearch: '',
          lengthMenu: '_MENU_ items/page',
        },
        dom: 'Bfrtip',
        buttons: [
          {extend: 'copy', className: 'btn btn-white'},
          {extend: 'csv', className: 'btn btn-white'},
          {extend: 'excel', className: 'btn btn-white'},
          {extend: 'pdf', className: 'btn btn-white'},
          {extend: 'print', className: 'btn btn-white'}
        ]
      });

      $('.datatables').DataTable({
        responsive: true,
        autoWidth: true,
        pagingType: "simple"
      });
      $('.datatables-desc').DataTable({
        order: [[ 0, "desc" ]],
        responsive: true,
        autoWidth: true,
        pagingType: "simple"
      });
      $('.datatables-export').DataTable({
        responsive: true,
        autoWidth: true,
        pagingType: "simple",
        language: {
          searchPlaceholder: 'Search...',
          sSearch: '',
          lengthMenu: '_MENU_ items/page',
        },
        dom: 'Bfrtip',
        buttons: [
          {extend: 'copy', className: 'btn btn-white'},
          {extend: 'csv', className: 'btn btn-white'},
          {extend: 'excel', className: 'btn btn-white'},
          {extend: 'pdf', className: 'btn btn-white'},
        {extend: 'print', className: 'btn btn-white'}
      ]
    });
    $('.segmentd.align-middleatatables').DataTable({
      "order": [[ 3, "desc" ]],
      responsive: true,
      autoWidth: true,
      pagingType: "simple"
    });
    $('#audience-deployments-table').DataTable({
      order: [[0, 'asc']],
      columns: [null, null, null, { searchable: false }]
    });
    $('#campaignTargetTable').DataTable({
      responsive: true,
      autoWidth: true,
      dom: 'Bfrtip',
      bFilter: false,
      buttons: [
        {extend: 'copy', className: 'btn btn-white'},
        {extend: 'csv', className: 'btn btn-white'},
        {extend: 'excel', className: 'btn btn-white'},
      ]
    });
    $('#pagesTable').DataTable({
      "order": [[ 1, "desc" ]]
    });
    $('#segmentsTable').DataTable({
      "order": [[ 1, "desc" ]]
    });
    $('.performance-reports-table').DataTable({
      order: [[ 2, "desc" ]],
      responsive: true,
      searching: false,
      paging: false,
      info: false
    });
    $('.productDatatables').DataTable({
      "order": [[ 6, "asc" ]],
      "columnDefs": [
        { "orderable": false, "targets": 7 },
        { "orderable": false, "targets": 0 }
      ]
    });
    $('#claims-table').DataTable({
      order: [[ 0, "desc" ]],
      responsive: true,
      autoWidth: true,
      pagingType: "simple",
      language: {
        searchPlaceholder: 'Search...',
        sSearch: '',
        lengthMenu: '_MENU_ items/page',
      },
      dom: 'Bfrtip',
      buttons: [
        {extend: 'copy', className: 'btn btn-white'},
        {extend: 'csv', className: 'btn btn-white'},
        {extend: 'excel', className: 'btn btn-white'},
        {extend: 'pdf', className: 'btn btn-white'},
        {extend: 'print', className: 'btn btn-white'}
      ]
    });
  };

  var loadDataTablesScript = function() {
    const script = document.createElement('script');
    script.src = 'https://cdn.datatables.net/v/bs4/moment-2.29.4/jszip-3.10.1/dt-2.3.1/b-3.2.3/b-html5-3.2.3/b-print-3.2.3/r-3.0.4/datatables.min.js';
    script.integrity = 'sha384-2MeMraxQRv+SPBJoZwxzyKseqgcYkIZpCT4oykv+tRYNiiKftnoiujCy8nblZ+7O';
    script.crossOrigin = 'anonymous';
    script.onload = loadDefaultDatatables;
    document.head.appendChild(script);
  };


  var loadPdfMakeFontsScript = function() {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/vfs_fonts.js';
    script.integrity = 'sha384-/RlQG9uf0M2vcTw3CX7fbqgbj/h8wKxw7C3zu9/GxcBPRKOEcESxaxufwRXqzq6n';
    script.crossOrigin = 'anonymous';
    script.onload = loadDataTablesScript;
    document.head.appendChild(script);
  };

  var loadPdfMakeScript = function() {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/pdfmake.min.js';
    script.integrity = 'sha384-VFQrHzqBh5qiJIU0uGU5CIW3+OWpdGGJM9LBnGbuIH2mkICcFZ7lPd/AAtI7SNf7';
    script.crossOrigin = 'anonymous';
    script.onload = loadPdfMakeFontsScript;
    document.head.appendChild(script);
  };

  var loadDataTablesStyle = function() {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.datatables.net/v/bs4/moment-2.29.4/jszip-3.10.1/dt-2.3.1/b-3.2.3/b-html5-3.2.3/b-print-3.2.3/r-3.0.4/datatables.min.css';
    link.integrity = 'sha384-H/SoJcGXjm5SYMvpc3CfBcT5AOo80Ib/5SqH52dXXEPWRr2fQ+9929QZKpzH6sT6';
    link.crossOrigin = 'anonymous';
    link.onload = loadPdfMakeScript;
    document.head.appendChild(link);
  };

  loadDataTablesStyle();

}
